import { render } from "./v-dialog.vue?vue&type=template&id=5a73a4be&scoped=true"
import script from "./v-dialog.vue?vue&type=script&lang=js"
export * from "./v-dialog.vue?vue&type=script&lang=js"

import "./v-dialog.vue?vue&type=style&index=0&id=5a73a4be&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a73a4be"]])

export default __exports__